import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import AutoAPI from '../../../api/AutomationAPI';
import Condition from './Condition';
import Scheduler from './Scheduler';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import AutomationModel from './AutomationModel';
import AutomationAction from './AutomationAction';
import AutomationCreation from './AutomationCreation';
import AutomationModelUpdate from './AutomationModelUpdate';

class AutomationUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    const id = parseInt(props.match.params.id);
    this.state = {
      inApiCall: id !== 0, id: id, name: '', description: '',
      condition: Const.True, changed: false
    };
    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.mainModel.email_config.options.push({ label: 'Called User', value: -1 });
    this.mainModel.email_config.options.push({ label: 'User Owner', value: -2 });

    this.modelName = null;
    this.model = null;
    this.fields = [];

    this.basePath = this.props.match.path
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/'));

    this.scheduler = {};
    this.conditions = [{}];
    this.updates = [{}];
    this.autoModel = {};
    this.autoAction = {};

    this.isScheduler = this.user.package && this.user.package > 1;
  }

  componentDidMount() {
    if (this.state.id !== 0) {
      AutoAPI.get(this.state.id, this.onReceived, this.onFail);
    }
  }
  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ inApiCall: false });}

  onReceived = auto => {

    this.conditions = JSON.parse(auto.conditions);
    this.updates = JSON.parse(auto.updates);

    const key = Object.keys(this.mainModel).find(model =>
      this.mainModel[model].model_no === auto.model);
    this.model = this.mainModel[key];
    this.fields = FieldController.getFilterFields(this.model.fields);

    this.scheduler = { execute: !!auto.execute, execute_no: auto.execute_no, execute_select: auto.execute_select };

    this.autoModel = {};
    this.autoModel.action = auto.action;
    this.autoModel.model = key;

    this.autoAction = {};
    let options = this.mainModel.sms_config.options;
    this.autoAction.smsVendor = options.find(opt => opt.value === auto.sms_vendor);
    this.autoAction.modelSms = auto.sms_model === Const.True;
    this.autoAction.staffSms = auto.sms_staff === Const.True;
    this.autoAction.reportSms = auto.sms_reporting === Const.True;
    this.autoAction.smsUsers = auto.sms_user === Const.True;
    this.autoAction.modelSmsTmp = this.getSmsOpt(auto.sms_tmp_model);
    this.autoAction.staffSmsTmp = this.getSmsOpt(auto.sms_tmp_staff);
    this.autoAction.reportSmsTmp = this.getSmsOpt(auto.sms_tmp_reporting);
    this.autoAction.smsUsersTmp = this.getSmsOpt(auto.sms_tmp_user);
    this.autoAction.smsUsersSelection = this.getUserOpt(auto.sms_users);

    options = this.mainModel.email_config.options;
    this.autoAction.emailVendor = options.find(opt => opt.value === auto.email_vendor);
    this.autoAction.modelEmail = auto.email_model === Const.True;
    this.autoAction.staffEmail = auto.email_staff === Const.True;
    this.autoAction.reportEmail = auto.email_reporting === Const.True;
    this.autoAction.mailUsers = auto.email_user === Const.True;
    this.autoAction.modelEmailTmp = this.getEmailOpt(auto.email_tmp_model);
    this.autoAction.staffEmailTmp = this.getEmailOpt(auto.email_tmp_staff);
    this.autoAction.reportEmailTmp = this.getEmailOpt(auto.email_tmp_reporting);
    this.autoAction.mailUsersTmp = this.getEmailOpt(auto.email_tmp_user);
    this.autoAction.mailUsersSelection = this.getUserOpt(auto.email_users);

    this.autoAction.modelWhatsApp = auto.whatsapp_model === Const.True;
    this.autoAction.staffWhatsApp = auto.whatsapp_staff === Const.True;
    this.autoAction.reportWhatsApp = auto.whatsapp_reporting === Const.True;
    this.autoAction.whatsappUsers = auto.whatsapp_user === Const.True;
    this.autoAction.modelWhatsAppTmp = this.getWhatsAppOpt(auto.whatsapp_tmp_model);
    this.autoAction.staffWhatsAppTmp = this.getWhatsAppOpt(auto.whatsapp_tmp_staff);
    this.autoAction.reportWhatsAppTmp = this.getWhatsAppOpt(auto.whatsapp_tmp_reporting);
    this.autoAction.whatsappUsersTmp = this.getWhatsAppOpt(auto.whatsapp_tmp_user);
    this.autoAction.whatsappUsersSelection = this.getUserOpt(auto.whatsapp_users);

    this.autoAction.staffNotify = auto.notify_staff === Const.True;
    this.autoAction.reportNotify = auto.notify_reporting === Const.True;

    this.autoAction.auto_call = auto.auto_call === Const.True;
    this.autoAction.meeting = auto.meeting === Const.True;
    this.autoAction.pipeline = auto.pipeline === Const.True;

    this.setState({ ...this.state, id: auto.id, name: auto.name, description: auto.description, condition: auto.condition_option });
  }

  onSchedulerChange = (execute, execute_no, execute_select) => {
    this.scheduler = { execute, execute_no, execute_select };
  }

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  desChange = event => this.setState({ ...this.state, description: event.target.value });
  modelChange = selected => {
    if (selected.model !== '') {
      this.autoModel = selected;
      this.modelName = selected.model;
      this.model = this.mainModel[selected.model];
      this.conditions = [{}];
      this.fields = FieldController.getFilterFields(this.model.fields);
      this.setState({ ...this.state, changed: !this.state.changed });
    }
  }

  onAction = (field, val) => this.autoAction[field] = val;
  onConditionChanged = conditions => this.conditions = conditions;
  onUpdateChanged = updates => this.updates = updates;

  getSmsOpt = val => val !== 0 ? this.mainModel.sms_temp.options.find(opt => opt.value === val) : val;
  getEmailOpt = val => val !== 0 ? this.mainModel.email_temp.options.find(opt => opt.value === val) : val;
  getWhatsAppOpt = val => val !== 0 ? this.mainModel.whatsapp_temp.options.find(opt => opt.value === val) : val;
  getUserOpt = val => val? this.mainModel.user.options.filter(opt =>
    val.includes(`${Const.Opt}${opt.value}${Const.Opt}`)) : [];
  toggleChange = tog => this.setState({ ...this.state, condition: tog ? Const.True : Const.False });
  getValue = option => option !== undefined ? option !== 0 ? option.value : option : 0;

  onSave = () => {
    let conditions = this.conditions.map(filter => {
      if (Object.keys(filter).length === 0 || !filter.field) return {};
      else return {
        field: filter.field.value,
        type: filter.field.type, condition: filter.condition.value, value: filter.value
      }
    });
    conditions = JSON.stringify(conditions);
    let updates = this.updates.map(update => {
      if (Object.keys(update).length === 0) return {};
      else return { 
        model: update.model,
        field: update.field.value,
        action: update.action.value,
        type: update.field.type,
        value: update.value
      };
    });
    updates = JSON.stringify(updates);
    this.setState({ ...this.state, inApiCall: true });
    const auto = {
      id: this.state.id, name: this.state.name, condition_option: this.state.condition,
      description: this.state.description, conditions, updates, ...this.scheduler,
      execute: this.scheduler.execute ? Const.True : Const.False
    };

    auto.model = this.model.model_no;
    auto.action = this.autoModel.action;

    auto.sms_vendor = this.getValue(this.autoAction.smsVendor);
    auto.sms_model = this.autoAction.modelSms ? Const.True : Const.False;
    auto.sms_staff = this.autoAction.staffSms ? Const.True : Const.False;
    auto.sms_reporting = this.autoAction.reportSms ? Const.True : Const.False;
    auto.sms_user = this.autoAction.smsUsers ? Const.True : Const.False;
    auto.sms_tmp_model = this.getValue(this.autoAction.modelSmsTmp);
    auto.sms_tmp_staff = this.getValue(this.autoAction.staffSmsTmp);
    auto.sms_tmp_reporting = this.getValue(this.autoAction.reportSmsTmp);
    auto.sms_tmp_user = this.getValue(this.autoAction.smsUsersTmp);
    auto.sms_users = this.autoAction.smsUsersSelection 
      ? Const.Opt + this.autoAction.smsUsersSelection.map(item => item.id).join(Const.Opt) + Const.Opt
      : '';

    auto.email_vendor = this.getValue(this.autoAction.emailVendor);
    auto.email_model = this.autoAction.modelEmail ? Const.True : Const.False;
    auto.email_staff = this.autoAction.staffEmail ? Const.True : Const.False;
    auto.email_reporting = this.autoAction.reportEmail ? Const.True : Const.False;
    auto.email_user = this.autoAction.mailUsers ? Const.True : Const.False;
    auto.email_tmp_model = this.getValue(this.autoAction.modelEmailTmp);
    auto.email_tmp_staff = this.getValue(this.autoAction.staffEmailTmp);
    auto.email_tmp_reporting = this.getValue(this.autoAction.reportEmailTmp);
    auto.email_tmp_user = this.getValue(this.autoAction.mailUsersTmp);
    auto.email_users = this.autoAction.mailUsersSelection 
      ? Const.Opt + this.autoAction.mailUsersSelection.map(item => item.id).join(Const.Opt) + Const.Opt
      : '';

    auto.whatsapp_model = this.autoAction.modelWhatsApp ? Const.True : Const.False;
    auto.whatsapp_staff = this.autoAction.staffWhatsApp ? Const.True : Const.False;
    auto.whatsapp_reporting = this.autoAction.reportWhatsApp ? Const.True : Const.False;
    auto.whatsapp_user = this.autoAction.whatsappUsers ? Const.True : Const.False;
    auto.whatsapp_tmp_model = this.getValue(this.autoAction.modelWhatsAppTmp);
    auto.whatsapp_tmp_staff = this.getValue(this.autoAction.staffWhatsAppTmp);
    auto.whatsapp_tmp_reporting = this.getValue(this.autoAction.reportWhatsAppTmp);
    auto.whatsapp_tmp_user = this.getValue(this.autoAction.whatsappUsersTmp);
    auto.whatsapp_users = this.autoAction.whatsappUsersSelection 
      ? Const.Opt + this.autoAction.whatsappUsersSelection.map(item => item.id).join(Const.Opt) + Const.Opt
      : '';

    auto.notify_staff = this.autoAction.staffNotify ? Const.True : Const.False;
    auto.notify_reporting = this.autoAction.reportNotify ? Const.True : Const.False;
    
    auto.auto_call = this.autoAction.auto_call ? Const.True : Const.False;
    auto.meeting = this.autoAction.meeting ? Const.True : Const.False;
    auto.pipeline = this.autoAction.pipeline ? Const.True : Const.False;

    AutoAPI.save(auto, this.onSaved, this.onFail);
  }
  
  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  }

  render() {
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">

          <div className="row"><div className="col-md-12"><h3>Workflow Automation</h3></div></div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-6">
                <div className="form-group">
                  <FormControl type='text' placeholder='Name'
                    className="mr-sm-2" value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <Form.Group className="mb-3">
                    <Form.Label>Discription</Form.Label>
                    <Form.Control as="textarea" rows={3}
                      className="mr-sm-2" value={this.state.description} onChange={this.desChange} />
                  </Form.Group>
                </div>
              </div>

              <div className="formhead col-md-12"><h4>Module</h4></div>
              <AutomationModel models={this.mainModel} onChange={this.modelChange} value={this.autoModel} />

              <Scheduler scheduler={this.scheduler} onSchedulerChange={this.onSchedulerChange}
                active={this.isScheduler} />

              {this.model && this.autoModel.action &&
                <>
                  <div className="formhead col-md-12">
                    <h4>Condition</h4>
                    <div className="display-flixr">
                      <div className="col-md-1">
                        <Form.Check type="radio">
                          <Form.Check.Input type="radio" checked={this.state.condition === Const.True}
                            onChange={() => this.toggleChange(true)} />
                          <Form.Check.Label>AND</Form.Check.Label>
                        </Form.Check>
                      </div>
                      <div className="col-md-2">
                        <Form.Check type="radio">
                          <Form.Check.Input type="radio" checked={this.state.condition !== Const.True}
                            onChange={() => this.toggleChange(false)} />
                          <Form.Check.Label>OR</Form.Check.Label>
                        </Form.Check>
                      </div>
                    </div>
                  </div>

                  <Condition model={this.model} fields={this.fields} eKey="conditions"
                    value={this.conditions} onConditionChanged={this.onConditionChanged} />

                  <div className="formhead col-md-12"><h4>Field Updation</h4></div>
                  <AutomationModelUpdate models={this.mainModel} value={this.updates} model={this.modelName}
                    onUpdateChanged={this.onUpdateChanged} />

                  <div className="formhead col-md-12"><h4>Automation</h4></div>
                  <AutomationAction mainModel={this.mainModel} onChange={this.onAction}
                    value={this.autoAction} />

                  <div className="formhead col-md-12"><h4>Creations</h4></div>
                  <AutomationCreation mainModel={this.mainModel} onChange={this.onAction}
                    value={this.autoAction} />

                  <div className="col-md-12 text-center btnsend">
                    <Button variant="success" onClick={this.onSave}>Save</Button>
                  </div>
                </>
              }
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(AutomationUpdate);
